import { z } from 'zod';

export const SpeakerRoleSchema = z.enum(['patient', 'clinician']);

export const DiarisedSpeakerSchema = z.object({
  speaker_id: z.string(),
  label: z.string().nullable(),
  // Session overlay from the transcription-service speaker-roles PATCH; null when no role is set.
  role: SpeakerRoleSchema.nullable().optional(),
});

export const WordSchema = z.object({
  word: z.string(),
  start: z.number(),
  end: z.number(),
});

export const DiarisedSegmentSchema = z.object({
  segment_id: z.number(),
  speaker_id: z.string(),
  start_time: z.number().nullable().optional(),
  end_time: z.number().nullable().optional(),
  text: z.string(),
  words: z.array(WordSchema),
  // Row offset within the stored segment; 0 for an unsplit row. Echo it with
  // segment_id when addressing this row on PATCH segment-speakers.
  segment_offset: z.number().int().nonnegative().optional(),
});

export const DiarisedTranscriptSchema = z.object({
  text: z.string(),
  speakers: z.array(DiarisedSpeakerSchema),
  segments: z.array(DiarisedSegmentSchema),
  duration: z.number(),
});

export const DiarisationStatusSchema = z.enum(['pending', 'completed', 'unavailable']);
